// Vendor Libs
import React from 'react';

// Components
import FlexDashboard from '../core/flex-dashboard';
import Health from '../search-data/health';
import Permissions from '../core/permissions';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Health',
                        component: Health,
                    },
                ],
            },
        ],
    },
};

function DashboardHealth() {
    return (
        <Permissions adminOnly={true} autoRedirect={true}>
            <FlexDashboard dashboardConfig={getDashboardConfig(dashboardConfig)} dashboardName="health" version="1" />
        </Permissions>
    );
}

export default DashboardHealth;
